module.exports = __webpack_public_path__ + "static/media/azimut-icons.2bf92807.ttf";